import axios from 'axios';
import queryString from 'query-string';

const axiosClient = axios.create({
  baseURL: 'https://workroom.viesoftware.vn:8002/api',
  headers: {
    'content-type': 'application/json',
  },
  paramsSerializer: (params) => queryString.stringify(params),
  // timeout: 3000,
});

axiosClient.interceptors.response.use(
  (response) => {
    if (response && response.data) return response.data;

    return response;
  },
  (error) => {
    //handle error
    if (error.response)
      console.log({
        code: error.response.status,
        message: error.response.data.message,
      });
    throw error;
  }
);

export default axiosClient;
